<template>
  <div class="bus-page">
    <div v-if="scrolling" class="sticky-mobile-menu">
      <div class="sticky-mobile-menu__wrapper">
        <ul class="menu">
          <li :class="isOverview ? 'active' : '' "><span @click="scrollMeTo('overview', true)">Overview</span></li>
          <li :class="isAdvertisement ? 'active' : '' "><span @click="scrollMeTo('advertisement', true)">Advertisement</span></li>
          <li :class="isPhotos ? 'active' : '' "><span @click="scrollMeTo('photos', true)">Photos</span></li>
        </ul>
      </div>
    </div>
    <div class="bus-detail" @click="toggleOrder(0)">
      <div v-if="!infoLoaded" class="loading-container"> 
        <adx-loading />
      </div>
      <div class="bus-detail__info">
        <div v-if="infoLoaded" class="bus-detail__info__left">
          <!-- header title -->
          <div class="bus-detail__info__left__header">
            <h2 class="large-title title">{{busDetail.title}}</h2>
            <div class="bus-icon">
              <img v-if="busDetail.brand_image" :src="busDetail.brand_image"/>
              <img v-else :src="`/img/notfound/img-placeholder_landscape.jpg`" alt="">
            </div>
          </div>
          <!-- tab menu  -->
          <div class="bus-detail__info__left__wrapper">
            <ul class="menu">
              <li :class="isOverview ? 'active' : '' "><span @click="scrollMeTo('overview')">Overview</span></li>
              <li :class="isAdvertisement ? 'active' : '' "><span @click="scrollMeTo('advertisement')">Advertisement</span></li>
              <li :class="isPhotos ? 'active' : '' "><span @click="scrollMeTo('photos')">Photos</span></li>
            </ul>
          </div>
          <!-- overview  -->
          <div ref="overview" class="bus-detail__info__left__about">
            <div class="bus-detail__info__left__about__overview" >
              <div class="item">
                <span>Est. trip </span><span class="strong">{{busDetail.trip}}</span>
              </div>
              <div class="item">
                <span>Trip distance </span><span class="strong">{{busDetail.distance}}</span>
              </div>
              <div class="item">
                <span>Est. Impression </span><span class="strong">{{busDetail.impression}}</span>
              </div>
               <div class="item">
                <span>Category </span><span class="strong">{{busDetail.category_title}}</span>
              </div>
            </div>
          </div>
          <!-- package advertisment -->
          <div ref="advertisement" v-if="placementBuses.buses && placementBuses.buses.length > 0" class="bus-detail__info__left__advertisment">
            <h1>{{placementBuses.buses && placementBuses.buses.length }} AVAILABLE ADVERTISEMENT</h1>
            <div class="expandable-level2" v-for="(item, index) in itemMedia" :key="index">
              <adx-expandable-level2 :item="item" :list="placementBuses" :viewPhoto="true" 
               :tagPhoto="true" :showSaved="false"
                @addToCampaign="addToOrder"
                @previewImage="itemPreview"
              />
            </div>
          </div>
          <!-- photos -->
          <div id="photos" ref="photos" class="bus-detail__info__left__photos">
            <h1>PHOTOS</h1>
            <div v-for="(item, index) in placementImages" :key="index" class="bus-detail__info__left__photos__reg-photos">
              <div v-if="item.contents && item.contents.length > 0">
                  <h1>{{item.placement_bus}}</h1>
                <div>
                  <grid-card :min="100" :column="'5'" :gap="8">
                    <template slot="item">
                      <img v-for="(image, index) in item.contents" :key="index" class="img-rounded" :src="image.content_url" alt="" @click="photosPreview(1, item.contents, index)" >
                    </template>
                  </grid-card>
                </div>
              </div>
            </div>
            <div v-for="(item, index) in placementImages" :key="index + 'mobile-reg'" class="bus-detail__info__left__photos__reg-photos-mobile">
              <div v-if="item.contents && item.contents.length > 0">
                <h1>{{item.placement_bus}}</h1>
                <div>
                  <grid-card :min="100" :column="'2'" :gap="8">
                    <template slot="item">
                      <img v-for="(image, index) in item.contents" :key="index" class="img-rounded" :src="image.content_url" alt="" @click="photosPreview(1, item.contents, index)" >
                    </template>
                  </grid-card>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- right section content -->
        <div v-if="infoLoaded" class="bus-detail__info__right">
          <div class="bus-detail__info__right__forbidden">
            <div class="bus-detail__info__right__forbidden--title">
              <i class="icon-warning"></i>
              <span>Forbidden Advertisement</span>
            </div>
            <div class="bus-detail__info__right__wrapper">
              <div v-if="busDetail.forbidden_ads">
                <div class="bus-detail__info__right__wrapper--content">
                  <p>{{busDetail.forbidden_ads}}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="bus-detail__info__right__address">
            <div class="bus-detail__info__right__address--title">
              <i class="icon-pin"></i>
              <span>Route Detail</span>
            </div>
            <div class="bus-detail__info__right__address--content">
              <div class="button-action">
                <button class="btn-regular secondary" @click="toggleMap(1)">View Maps</button>
              </div>
              <div class="map-wrapper" :key="keyMapRef">
                <GmapMap
                  class="map"
                  :center="{lat:-6.1944935, lng:106.7643612}"
                  :zoom="12"
                  map-type-id="terrain"
                  style="width: 100%; position: relative;top: 0; left: 0;right: 0;bottom: 0;height: 140px;"
                  ref="mapRef"
                  :options="{
                    zoomControl: true,
                    mapTypeControl: true,
                    streetViewControl: false,
                    rotateControl: false,
                    fullscreenControl: false,
                    disableDefaultUi: false
                  }"
                  >
                </GmapMap>
              </div>
            </div>
            <div class="bus-detail__info__right__address--content">
              <ul class="line">
                <li v-for="(route, index) in routes" :key="index" class="subhead">{{route.location}}</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <!-- modal image in advertisment item -->
      <adx-modal v-if="isPreview" @modal-close="togglePreview(0)" :type="`full`" :color="`transparant`">
        <div slot="content" class="content">
          <div class="wrapper">
            <adx-detail-slider :isImageShow="true" :isCenter="true" :slide="1" :arrowMobile="true" @current="getCurrent" @init="getCount" :data="regularPhoto"/>
          </div>
        </div>
      </adx-modal>
    </div>
    <!-- modal preview regular photo -->
    <adx-modal v-if="isPreviewModal" @modal-close="photosPreview(0)" :type="`full`" :color="`transparant`">
      <div slot="content" class="content">
        <div class="wrapper">
        <adx-detail-slider :isImageShow="true" :slide="1" :arrowMobile="true" @current="getCurrent" @init="getCount" :data="regularPhoto" :imageIndex="imageIndex" />
        </div>
      </div>
    </adx-modal>
    <!-- Maps Modal -->
    <adx-modal v-if="isShowMap" @modal-close="toggleMap(0)" :type="`full`" :color="`transparant`">
      <div slot="content" class="modal-map">
        <div class="map-wrapper">
          <GmapMap
            class="map"
            :center="{lat:-6.1944935, lng:106.7643612}"
            :zoom="12"
            map-type-id="terrain"
            style="width: 100%; position: relative;top: 0; left: 0;right: 0;bottom: 0;height: 400px;"
            ref="refMap"
            :options="{
              zoomControl: true,
              mapTypeControl: true,
              streetViewControl: false,
              rotateControl: false,
              fullscreenControl: false,
              disableDefaultUi: false
            }"
            >
          </GmapMap>
        </div>
        <div class="map-title">
          <span>Rute {{ busDetail.category_title}} </span>
          <span class="strong"> {{ busDetail.title}} </span>
        </div>
      </div>
    </adx-modal>
    <!-- order summary modal -->
    <div v-if="isViewOrder" class="modal-summary_wrapper" >
    <div class="modal-summary__background" @click="toggleOrder(0)"> </div>
    <div class="order-summary">
      <div><i class="icon-close" @click="toggleOrder(0)"></i></div>
      <div class="order-summary__wrapper">
        <h1 class="subhead title">Order Summary</h1>
        <div class="period"><adx-selectdropdown class="dropdown subhead" :label="`Period of Campaign`" :value.sync="selectedPeriod" :options="period" /></div>
        <div class="order-summary__wrapper__top">
          <div class="calendar">
            <v-date-picker
              v-model='startDate'
              :popoverVisibility="popoverVisibility"
              :min-date='nextweek'
              :theme-styles='themeStyles'
              class='date-picker'>
              <div class="field" slot-scope='{ inputValue, updateValue }'>
                <div class="start_date">
                  <label class="mini-font calendar-label">Start Date</label>
                  <input
                    class="date-picker-input subhead"
                    type='text'
                    required
                    readonly
                    :value='inputValue'
                    @input='updateValue($event.target.value, { formatInput: false, hidePopover: false })'
                    @change='updateValue($event.target.value, { formatInput: true, hidePopover: false })'/>
                </div>
                <div class="arrow">
                  <i class="icon-arrow-forward"></i>
                </div>
                <div class="end_date">
                  <label class="mini-font color-grey calendar-label">End Date</label>
                  <input 
                    class="color-grey date-picker-input subhead"
                    placeholder= "DD/MM/YYYY"
                    type='text'
                    required
                    readonly
                    :value='getDate(endDate)'
                    ref="endDate"
                    @input='updateValue($event.target.value, { formatInput: false, hidePopover: false })'
                    @change='updateValue($event.target.value, { formatInput: true, hidePopover: false })'/>
                  <!-- </v-date-picker> -->
                </div>
              </div>
            </v-date-picker>
          </div>
        </div>
        <!-- <div class="order-summary__wrapper__title">
          <h1 class="subhead">Selected Advertisement</h1>
        </div> -->
        <div class="order-summary__wrapper__detail" v-if="selectedOrders.length > 0"> 
          <div class="order-summary__wrapper__title">
            <h1 class="subhead">Selected Advertisement</h1>
          </div>
          <div class="order-summary__wrapper__detail__order">
            <div v-for="(order, index) in selectedOrders" :key="index" class="order-summary__wrapper__detail__order__content">
              <div class="detail">
                <div class="detail__left">
                  <span class="icon"  @click="deleteOrder(index)"><i class="icon-deleted"></i></span>
                  <div class="item-detail">
                    <div class="category-title">
                      <span class="mini-font  to-uppercase color-grey">{{order.category}}</span>
                    </div>
                    <div class="rute-title">
                      <h1 class="subhead">{{order.title}}</h1>
                    </div>
                    <div class="placement-title">
                      <span class="subhead">{{order.placement}}</span>
                    </div>
                    <div class="quantity-dropdown">
                      <adx-selectdropdown :size="`small`" :options="dropdownBus" :value.sync="order.count" :selected="selectedNumber(order)" />
                    </div>
                  </div>
                </div>
                <div class="detail__right">
                  <span class="subhead">{{ getItemPrice(order.price * order.count) | formatMoney}}</span>
                </div>
              </div>
            </div>
          </div>
          <div v-if="selectedOrders.length > 0" class="order-summary__wrapper__detail__price">
            <div class="ppn">
              <h1 class="subhead">PPN 10%</h1>
              <h1 class="ppn-price subhead">{{ (0.1 * getTotal())  | formatMoney}}</h1>
            </div>
            <div class="ppn-title">
              <h1 class="subhead">Total Order</h1>
            </div>
            <div class="total-order">
              <span>{{ getTotalByPPN() | formatMoney}}</span>
            </div>
          </div>
        </div>
        <div class="order-summary__wrapper__text" v-else>
          <span class="order-summary__wrapper__text__empty"> 
            Please select at least one advertisement to add an order 
          </span>
        </div>
        <!--  -->
        <div class="order-summary__wrapper__mobile-button">
          <button v-if="!campaignId" class="btn-block primary continue" :disabled="selectedOrders.length < 1 || isLoadingContinue" @click="createCampaign">
            Continue <adx-loading-secondary v-if="isLoadingContinue"/>
          </button>
          <button v-else class="btn-block primary continue" :disabled="selectedOrders.length < 1 || isLoadingContinue" @click="editCampaign">
            Continue <adx-loading-secondary v-if="isLoadingContinue"/>
          </button>
        </div>
      </div>
    </div>
    </div>
    <!-- sticky footer -->
    <div class="footer-bus" :class="[isViewOrder?'footer-mobile': '']">
      <div v-if="!isOrderAvailable" class="footer-bus__wrapper">
        <div class="footer-bus__wrapper__left">
          <h1 class="available-adv">{{placementBuses.buses && placementBuses.buses.length}} AVAILABLE ADVERTISEMENT</h1>
        </div>
        <div class="footer-bus__wrapper__right">
          <div class="footer-bus__wrapper__right__total-price">
            <div class="header">
              <span>Price per month start from</span>
            </div>
            <div class="header-mobile">
              <span>Price Starting </span>
            </div>
            <div class="price">
              <span>{{ 30000000 | formatMoney}}</span>
            </div>
            <div class="price-mobile">
              <span>per month</span>
            </div>
          </div>
          <div class="footer-bus__wrapper__right__select-adv">
            <div class="add-desktop"><button class="btn-large primary" @click="scrollMeTo('advertisement')">Select Advertisement</button></div>
            <div class="add-mobile"><button class="btn-large primary" @click="scrollMeTo('advertisement')">View Advertisement</button></div>
          </div>
        </div>
      </div>
      <div v-else class="footer-bus__wrapper-2">
        <div class="footer-bus__wrapper-2__left">
          <span>You have {{selectedOrders.length}} item in order</span>
        </div>
        <div class="footer-bus__wrapper-2__right">
          <div class="footer-bus__wrapper__right__total-price">
            <div class="header">
              <span>Total Order</span>
            </div>
            <div class="price">
              <span>{{ getTotalByPPN() | formatMoney}}</span>
            </div>
          </div>
          <div class="footer-bus__wrapper__right__select-adv">
            <div class="view"><button class="btn-large secondary view" @click="toggleOrder(1)">View Order</button></div>
            <div class="buttonContinue">
              <button  v-if="!campaignId" class="btn-large primary continue"  :disabled="selectedOrders.length < 1 || isLoadingContinue" @click="createCampaign">
                Continue <adx-loading-secondary v-if="isLoadingContinue"/> 
              </button>
              <button v-else class="btn-block primary continue" :disabled="selectedOrders.length < 1 || isLoadingContinue" @click="editCampaign">
                Continue <adx-loading-secondary v-if="isLoadingContinue"/>
              </button>
            </div>
          </div>
        </div>
        <div class="footer-bus__wrapper-2__view-order">
          <button class="btn-block primary" @click="toggleOrder(1)">
            <span>View Order</span>
            <span>{{selectedOrders.length}} item</span>
            <span>{{getTotalByPPN() | formatMoney}}</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as VueGoogleMaps from 'vue2-google-maps'
import Modal from '@/components/Modal'
import Input from '@/components/Form/Input'
import GridCard from '@/components/Grid/Card'
import Textarea from '@/components/Form/TextArea'
import LoadingPrimary from '@/components/Loading/Primary'
import DetailSlider from '@/components/Slider/DetailSlider'
import SelectDropdown from '@/components/Form/SelectDropdown'
import LoadingSecondary from '@/components/Loading/Secondary'
import LoadingSpin from '@/components/Loading/Secondary-white'
import ExpandableLevel2 from '@/components/ExpandableListItems/Level2'

import api from '@/api'
import axios from 'axios'
import moment from 'moment'
import calendar from 'v-calendar'
import { apiV2 } from '@/api/urls'
import { restEdge } from '@/api/edgeUrls'
import { formatShortDateTime, formatShortDate} from '@/lib/util'
import { formatNumber } from '@/lib/filter'
import { mapGetters, mapActions, mapMutations } from 'vuex'

export default {
  name: 'adx-detail-bus',
  components: {
    'adx-modal': Modal,
    'adx-input': Input,
    'grid-card': GridCard,
    'adx-textarea': Textarea,
    'adx-detail-slider': DetailSlider,
    'adx-loading': LoadingPrimary,
    'adx-loading-spin': LoadingSpin,
    'adx-selectdropdown': SelectDropdown,
    'adx-loading-secondary': LoadingSecondary,
    'adx-expandable-level2' : ExpandableLevel2,
  },
  props: {

  },
  data() {
    return {
      id: null,
      campaignId: null,
      admin: false,
      arr: [],
      busDetail: {
        title: null,
        brand_image: null,
        category_title: null,
        trip: null,
        distance: null,
        impression: null,
        seat: null,
        forbidden_ads:null,
      },
      countSlide: null,
      currentSlide: 1,
      dropdownBus:[],
      // endDate: null,
      imageIndex: 0,
      images:[],
      infoLoaded: false,
      inputValue: null,
      itemMedia:[],
      itemPhoto: [],
      isAdvertisement: false,
      isLoadingContinue: false,
      isOpen: false,
      isOverview: false,
      isPhotos: false,
      isPreview: false,
      isPreviewModal: false,
      isShowMap: false,
      isViewOrder: false,
      keyMapRef: false,
      kmlContent: [],
      lastSource : 0,
      selectedPeriod: 1,
      period: [],
      popoverVisibility: 'focus',
      placementBuses:[],
      placementImages:[],
      regularPhotos: [],
      routes:[],
      savedLoading: false,
      scrolling: false,
      selectedOrders:[],
      show: false,
      source: 0,
      startDate: null,
      // campaignStatus: null,
      orders: [],
      attributes: [
        {
          dot: {
            backgroundColor: '#ff3b30',
          },
          dates: [],
        },
      ],
      themeStyles: {
        dayContent: {
          fontSize: '15px',
        },
        headerTitle: {
          fontSize: '17px',
          fontWeight: 'bold'
        },
        weeks: {
          fontWeight: 'bold'
        },
        wrapper: {
          boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.16)',
          backgroundColor: 'white',
          border: 'none',
        },
        header: {
          marginBottom: '6px'
        },
        dayCellNotInMonth: {
          opacity: 0,
        }
      },
    }
  },
  computed: {
    google: VueGoogleMaps.gmapApi,
    ...mapGetters ({
      defaultSaved: 'default',
      token: 'token',
      account: 'account',
      userId: 'userId'
    }),
    nextweek() {
      var nextweek = new Date();
      nextweek.setDate(nextweek.getDate() + 7);
      return nextweek
    },
    isOrderAvailable() {
      return this.selectedOrders.length > 0
    },
    endDate: function(){
      var end = new Date(this.startDate);
      end.setDate(end.getDate() - 1)
      end.setMonth(end.getMonth() + this.selectedPeriod);
      return formatShortDate(end)
    },
    minimumPeriod: function(){
      return this.selectedOrders.length > 0 ? Math.max(...this.selectedOrders.map(item => parseInt(item.constraint.minPeriod))) : 1
    },
    getAllOrderData: function() {
      const data = {
        selectedOrders: this.selectedOrders || [],
        startDate: Date(this.startDate) || this.nextweek,
        selectedPeriod: this.selectedPeriod || this.minimumPeriod
      }
      return data
    }
  },
  watch: {
    selectedPeriod: function(newValue){
      this.$nextTick(() => {
        // Error message
        if (newValue < this.minimumPeriod) {
          this.showErrorNotification(`Minimum period is ${this.minimumPeriod}`)
          // Force set to minimum period
          this.selectedPeriod = this.minimumPeriod
        }
        //update data in local storage
        this.saveToLocal()
      });
    },
    startDate: function(newValue, oldValue){
      if(!newValue || newValue == oldValue) {
        this.startDate = oldValue
        this.popoverVisibility = 'hidden'
        this.$nextTick(() => this.popoverVisibility = 'focus')
      }
      this.saveToLocal()
    },
  },
  beforeCreate() {

  },
  created() {
    window.addEventListener('scroll', this.handleScroll());
  },
  beforeMount() {
    const { id } = this.$route.params
    this.id = id
    this.campaignId = this.$route.params.campaignId
  },
  async mounted() {
    window.scrollTo({ top: 0})
    this.admin = this.account.isStaff
    if (!this.token) {
      this.campaignId = null
      this.$router.replace({
        params: {
          campaignId: undefined
        }
      })
    }
    this.getPeriod()
    await this.initialLoad()
    await this.showKML()
    this.getValueMaxBus()
    this.isOverview = true

    let savedOrder = this.getFromLocal()
    this.selectedOrders = savedOrder.selectedOrders || []
    this.selectedPeriod = savedOrder.selectedPeriod || this.minimumPerio
    let date = savedOrder.selectedStart || this.nextweek
    this.startDate = new Date(date)
  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll());
  },
  methods: {
    initialLoad(){
      (async () => {
        const { data, status, statusText } = await api.get(restEdge.busDiscoveryDetail(this.id), {useRestEdge: true, needToken: true})
        if(status == 200){
          await this.mapData(data)
          this.infoLoaded = true
        } else{
          this.showErrorNotification(`Something went wrong. Please refresh the page!`)
        }
      })();
    },
    getPeriod() {
      let file = `/static/data/monthly_period.json`;
      (async () => {
        let request = await fetch(new Request(file))
        let data = await request.json()

        this.period = data.periods
      })();
    },
    getDate(){
      return formatShortDate(this.endDate)
    },
    async getValueMaxBus() {
      let bus = [...Array(21).keys()].slice(1).map((el) => {
        return {
          label: `${el} Bus`,
          value: el
        }
      })
      this.dropdownBus = await bus
    },
    async mapData(data) {
      //mapping bus detail
      let bus_category = data.category.title
      let listFeatured = data.contents.filter(x => x.is_featured == true).pop()
      let image = listFeatured? listFeatured.content_url : data.contents.length > 0? data.contents[0].content_url : null
      
      this.busDetail = {
        title: data.title,
        brand_image: image,
        category_title: data.category? data.category.title : '-',
        trip: data.trip? formatNumber(data.trip) + ' per day' : '-',
        distance: data.distance? formatNumber(data.distance) + ' Km' : '-',
        impression: data.impression? formatNumber(data.impression) + ' per day' : '-',
        seat: data.buses[0].seats,
        forbidden_ads: data.forbiddenAds,
      }
      this.routes = data.routeDetails

      //mapping adertisment item
      this.placementBuses = data
      let tempImages = []
      let tempBuses = []
      if(this.placementBuses.buses.length > 0){
       await this.placementBuses.buses.map( el =>{
          let listFeaturedPlacement = el.contents.filter(x => x.is_featured == true).pop()
          let imagePlacement = listFeaturedPlacement? listFeaturedPlacement.content_url : el.contents.length > 0? el.contents[0].content_url : null
          //mapping detail item
          let minPeriod = el.generic.minPeriod
          let minQuantity = el.generic.minQuantity
          let leadPreCampaign = el.generic.leadPreCampaign
          let desc = [
            "- " + el.generic.description,
            "- Minimum order " + minPeriod + " month(s)",
            "- Minimum quantity " + minQuantity + " unit(s)",
            "- Lead time " + leadPreCampaign + " day(s)",
            "- Bus type : " + el.vehicle.title,
          ]

          tempBuses.push({
            id: el.id,
            placement: el.generic.title,
            include_tax: false,
            description: desc,
            price: el.generic.price,
            period: el.generic.pricingPlan,
            photo: el.contents,
            thumbnail: imagePlacement,
            constraint: {
              minPeriod: minPeriod,
              minQuantity: minQuantity,
              leadPreCampaign: leadPreCampaign,
            }
          })
          // mapping photos from adertisment item
          tempImages.push({
            id: el.id,
            placement_bus: el.generic.title,
            contents : el.contents
          })
        })
      }
      this.placementImages = tempImages
      this.itemMedia = tempBuses

      //get kml route
      let kmlContent = []
      await kmlContent.push(data.fileRoute.content_url)
      await kmlContent.push(data.fileRoute.content_url)
      this.kmlContent = await kmlContent
      this.infoLoaded = false

      this.keyMapRef !=this.keyMapRef
      this.registerKML(kmlContent)
      this.showKML()
    },
    registerKML(kmlContent){
      let data = []
      setTimeout(async ()=>{ 
        for (let i = 0; i<2; i++){
          const x = await new google.maps.KmlLayer(kmlContent[i],{
            preserveViewport: false
          });
          data.push(x)
        } 
        this.arr = data
        this.showKML()
      }, 1000);
    },
    getTotal(){
      let total = 0
      if(this.selectedOrders.length > 0){
        let beforeTax = 0
        let afterTax = 0
        this.selectedOrders.forEach(element => {
          beforeTax = element.price * element.count * this.selectedPeriod 
          afterTax = (element.price * element.count * this.selectedPeriod)  / 1.1
          const item = element.include_tax ? afterTax : beforeTax
          total += item
        });
        return total
      }
    },
    getItemPrice(itemPrice){
      return itemPrice * this.selectedPeriod 
    },
    getTotalByPPN(){
      return this.getTotal() + (this.getTotal()* 0.1)
    },
    deleteOrder(index){
      this.selectedOrders.splice(index, 1)
      //update data in local storage
      this.saveToLocal()
    },
    async selectedNumber(item){
      let minQuantity = item.constraint.minQuantity
      if (item.count < minQuantity) {
        item.count = minQuantity
        this.showErrorNotification('Minimum quantity allowed for this campaign is ' + minQuantity)
      }
      //update data in local storage
      this.saveToLocal()
    },
    addToOrder(list, item){
      let price = item.include_tax? (item.price / 1.1): item.price

      let order = {
        item_id: item.id,
        title: list.title,
        price: price,
        category: list.category? list.category.title : '-',
        placement: item.placement,
        constraint: item.constraint,
        count: item.constraint.minQuantity
      }
      
      // Selected item ids
      const ordered = this.selectedOrders.map(x => {
        return x.item_id
      })
      if (ordered.includes(order.item_id)){
        const y = this.selectedOrders.filter(x => {
          return x.item_id == item.id
        })

        if (y[0].count >= 20) {
          this.showErrorNotification(`Item failed added to your order.`)
        }else {
          this.showSuccessNotification(`Item successfully added to your order.`)
          y[0].count += 1
        }
      } else {
        // Push to local variable for rendering
        this.selectedOrders.push(order)
        this.showSuccessNotification(`Item successfully added to your order.`)
      }
      // Set minimum period for the order and change period dropdown options
      if (this.selectedPeriod < this.minimumPeriod) {
        this.selectedPeriod = this.minimumPeriod
      }
      //update data in local storage
      this.saveToLocal()
      this.isViewOrder = true
    },
    createCampaign(){
      if (this.token) {
        let orders = []
        this.isLoadingContinue = true
        if (this.selectedOrders.length > 0 ) {
          this.selectedOrders.map(order => {
            orders.push({
              count: order.count,
              bus: parseInt(order.item_id)
            })
          })
        }
        let body = {
          campaignInfo: {
            title: "Untitled",
            start: moment(this.startDate).format('YYYY-MM-DD'),
            period: this.selectedPeriod,
            owner: this.userId
          },
          orderRoutes: orders
        };

        (async () => {
          const { data, status } = await api.post(restEdge.busDiscoveryAddCampaign, body, {useRestEdge: true, needToken: true})
          if(status == 200){
            let id = data.id
            this.isLoadingContinue = false
            this.resetLocalStorage()
            this.$router.push({path: `/bus/campaigneditor/${id}`})
          } else {
            this.showErrorNotification('Oops data can not be saved!')
            this.isLoadingContinue = false
          }
        })();
      } else {
        this.$router.push({name: 'signin', query: { next: this.$route.fullPath }})
      }

    },
    editCampaign(){
      this.isLoadingContinue = true
      let orders = []
      if (this.selectedOrders.length > 0 ) {
        this.selectedOrders.map(order => {
          orders.push({  
            count: order.count,
            bus: {
              id : parseInt(order.item_id)
            }
          })
        })
      }
      let body = {
        campaign_info: {
          start: moment(this.startDate).format('YYYY-MM-DD'),
          period: this.selectedPeriod,
        },
        order_routes: orders
      };
      
      (async () => {
        const { data, status } = await api.patch(restEdge.editBusCampaign(this.campaignId), body, {useRestEdge: true, needToken: true})
        if(status == 200){
          let id = data.id
          this.isLoadingContinue = false
          this.resetLocalStorage()
          this.$router.push({ name: 'buscampaigneditor', params: { id: id} })
        } else {
          this.showErrorNotification('Oops data can not be saved!')
          this.isLoadingContinue = false
        }
      })();
    },
    getCurrent(item) {
      this.currentSlide = item + 1
    },
    getCount(item) {
      this.countSlide = item
    },
    toggleOrder(isOpen){
      this.isViewOrder = (isOpen == 1)
    },
    toggleMap(isOpen){
      this.isShowMap = (isOpen == 1)
      this.registerKML(this.kmlContent)
      this.source = isOpen
    },
    showKML(){
      if( this.$refs.refMap){
        this.$refs.refMap.$mapPromise.then((map) => {
          let z = this.arr[1];
          if (z) z.setMap(map);
        });
      }
      if (this.$refs.mapRef) {
        this.$refs.mapRef.$mapPromise.then((map) => {
          let z = this.arr[0];
          if (z) z.setMap(map);
        });
      }
    },
    togglePreview(){
      this.isPreview = !this.isPreview
    },
    itemPreview(item){
      let tempPhotos = []
        if(item.photo.length > 0){
          item.photo.map( el =>{
            tempPhotos.push({
              caption: el.original,
              id: el.original,
              is_primary: false,
              thumbnail: el.content_url,
              url: el.content_url
            })
          })
        }
      this.regularPhoto = tempPhotos
      this.isPreview = !this.isPreview
    },
    photosPreview(isOpen, placementPhotos, index){
      if(isOpen == 1 ){
        let tempPhotos = []
        if(placementPhotos.length > 0){
          placementPhotos.map( el =>{
            tempPhotos.push({
              caption: el.original,
              id: el.original,
              is_primary: false,
              thumbnail: el.content_url,
              url: el.content_url
            })
          })
        }
        this.regularPhoto = tempPhotos
        this.imageIndex = index
        this.isPreviewModal = true
      } else{
        this.isPreviewModal = false
      }
    },
    scrollMeTo(refName, isMobile=false) {
      var element = this.$refs[refName]
      var top = element.offsetTop
      if(refName == 'overview'){
        this.isOverview = true
        this.isAdvertisement = false
        this.isPhotos = false
      } else if(refName == 'advertisement'){
        this.isOverview = false
        this.isAdvertisement = true
        this.isPhotos = false
      } else{
        this.isOverview = false
        this.isAdvertisement = false
        this.isPhotos = true
      }
      if (isMobile ) top -= 100
      window.scrollTo({ top: top, behavior: 'smooth' })
    },
    handleScroll() {
       window.onscroll = () => {
       let bottomOfWindow = Math.max(window.pageYOffset, document.documentElement.scrollTop, document.body.scrollTop) + window.innerHeight === document.documentElement.offsetHeight
        bottomOfWindow ?  this.scrolling = false : this.scrolling = true
     	}
    },
    getFromLocal() {
      let savedData = localStorage.getItem('selectedBusOrder')
      if (!savedData) {
        savedData = JSON.stringify({
          selectedOrders: [],
          selectedPeriid: 1,
          selectedStart: this.nextweek
        })
      }
      return JSON.parse(savedData)
    },
    saveToLocal(data = null){
      let busData = null
      if (data) {
        busData = data
      } else {
        busData = JSON.stringify({...this.getAllOrderData})     
      }
      localStorage.setItem('selectedBusOrder', busData)
    },
    resetLocalStorage(){
      let busData = JSON.stringify({
        selectedOrders: [],
        selectedPeriid: 1,
        selectedStart: this.nextweek
      })
      this.saveToLocal(busData)
    },
    showErrorNotification(param){
      this.$notify({
        group: 'saved',
        title: 'Error',
        text: param,
        type: 'danger'
      });
    },
    showSuccessNotification(param){
      this.$notify({
        group: 'saved',
        title: 'Success',
        text: param,
        type: 'success'
      });
    },

  },
}
</script>

<style lang='scss' scoped>
@import './index.scss';

</style>

<style lang="scss">
@import '~@/styles/variables';
@import '~@/styles/mixins';

.bus-page{
  .order-summary__wrapper {
    .period {
      .selectDropdown {
        .select__title {
          left: 8px;
        }
        input {
          padding-left: 8px;
          font-size: 15px;
        }
      }
    }
    &__detail__order__content {
      .detail {
        &__left {
          .item-detail {
            .quantity-dropdown {
              .selectDropdown {
                width: 60%;
                .popup {
                  height: 150px;
                  overflow: auto;
                  width: max-content;
                  &__background {
                    .item {
                      padding: 8px;
                      .text {
                        margin-left: -8px;
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    &__top {
      .selectDropdown{
        width: 50%;
      }
    }
  }

  .modal__content__header{
    margin-bottom: 32px;

    .title{
      font-size: 28px;
    }
  }

  .slick-slide img{
    img{
      width: 1080px;
      max-width: 100%;
    }
  }

  .slick-arrow{
    width: 32px;
    height: 32px;
    // left: -7%;
  }

  .img-container{
    img{
      object-fit: contain;
      margin: 0px;
      max-height: 630px;
      max-width: 1080px;
    }
  }

  .icon-close:before {
    font-size: 25px;
    font-weight: bold;
  }

  .gm-style-mtc, .gmnoprint{
    display: none;
  }
  .gridCard{
    img{
      display: flex;
      align-self: center;
    }
  }
  .expandableList__card__channels__content__left__info {
    span {
      display: inline-block;
      white-space: pre-line;
    }
  }
}


@include breakpoint(md) {

.bus-page{

  .modal__content.small{
    top: 0px;
    height: 100%;
    width: 100%;
  }

  .modal__content__header{
    display: block;

    button{
      display: unset;
    }
    .title{
      font-size: 24px;
      margin-left: 16px;
    }
  }
  .gridCard{
    display: grid;
    grid-template-columns: repeat(2, minmax(100px, 1fr));
    gap: 8px 8px;

    img{
      display: flex;
      align-self: center;
    }
  }

  .expandableList__card__channels__content__left__place-image {
    .thumbnail{
      width: 100%;
    }

    img {
      object-fit: contain;
    }
  }

  .order-summary__wrapper__top{
    .selectDropdown{
      width: 100%;
    }
  }
}
}
</style>
